<template>
  <div>
    <v-card max-width="1000" class="mx-auto" elevation="0">
      <v-row align="center" justify="center">
        <v-overlay color="White" :absolute="absolute" :value="overlay">
          <div class="text-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-overlay>
      </v-row>
      <br />
      <br />
      <v-subheader>Your Shopping Cart</v-subheader>
      <div v-if="countCart > 0">
        <v-card flat>
          <v-list three-line v-if="countCart > 0">
            <template v-for="(item, index) in carts">
              <v-list-item :key="'cart' + index">
                <v-list-item-avatar>
                  <v-img :src="getImage('/' + item.cover)"></v-img>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title v-html="item.title"></v-list-item-title>
                  <v-list-item-subtitle>
                    Rp. {{ item.price.toLocaleString("id-ID") }} ({{ item.weight }} gr)
                    <span style="float: right">
                      {{ item.quantity }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
          <v-container>
            <v-card-actions>
              Subtotal
              <v-spacer />
              Rp. {{ totalPrice.toLocaleString("id-ID") }}
            </v-card-actions>
          </v-container>
        </v-card>
      </div>
      <v-card dark color="orange" style="display: none">
        <v-card-text>
          COD(Rp.5000) tidak perlu pilih Courier, masih dalam wilayah jangkuan marketing
        </v-card-text>
      </v-card>
      <br />
      <v-subheader left style="display: none">Courier</v-subheader>

      <div>
        <v-card flat>
          <v-container>
            <v-select
              v-model="courier"
              :items="couriers"
              @change="getServices"
              item-text="text"
              item-value="id"
              label="Courier"
              persistent-hint
              single-line
            ></v-select>

            <v-select
              v-model="service"
              v-if="courier"
              :items="services"
              @change="calculateBill"
              item-text="resume"
              item-value="service"
              label="Courier Service"
              persistent-hint
              single-line
              update="selectPtmyId"
            ></v-select>

            <v-card-actions>
              Subtotal
              <v-spacer />
              Rp. {{ shippingCost.toLocaleString("id-ID") }}
            </v-card-actions>
            <v-card-actions>
              Biaya Layanan
              <v-spacer />
              Rp. {{ parseInt(setting.midtrans_cost).toLocaleString("id-ID") }}
            </v-card-actions>
          </v-container>
        </v-card>
      </div>

      <v-subheader>Total</v-subheader>

      <v-card>
        <v-container>
          <v-layout row wrap>
            <v-flex xs6 text-center>
              Total Bill ({{ totalQuantity }} items)
              <div class="title">{{ totalBill.toLocaleString("id-ID") }}</div>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs0 text-center class="mx-auto hidden-sm-and-down">
              <!-- :disabled="totalBill==0" -->

              <!-- @click="dialogConfirm = true" -->
              <v-btn
                color="#1B5E20"
                v-if="service"
                id="selectPtmyId"
                @click="selectPayment"
              >
                <v-icon rounded color="white" outlined elevation="5" large
                  >mdi-cash-sync</v-icon
                >
                &nbsp;
                <span class="white--text">Select Payment</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <br />
      <v-flex xs0 text-center class="mx-auto hidden-sm-and-up">
        <v-btn color="#1B5E20" v-if="service" @click="selectPayment">
          <v-icon rounded color="white" outlined elevation="5" large
            >mdi-cash-sync</v-icon
          >
          &nbsp;
          <span class="white--text">Select Payment</span>
        </v-btn>
      </v-flex>
      <br />

      <template>
        <v-layout row justify-center>
          <v-dialog
            v-model="dialogProsesed"
            persistent
            max-width="290"
            id="dialogProsesed"
          >
            <v-progress-linear indeterminate color="blue" height="30"
              ><span>Waits...</span></v-progress-linear
            >
          </v-dialog>
        </v-layout>
      </template>

      <template>
        <v-layout row justify-center>
          <v-dialog v-model="dialogConfirm" persistent max-width="290" id="dialogConfirm">
            <v-card>
              <v-card-title class="headline" align="center" justify="center"
                >Select Payment</v-card-title
              >
              <v-card-actions>
                <v-layout class="overflow-visible" style="height: 56px">
                  <v-bottom-navigation
                    v-model="selectedPayment"
                    color="blue"
                    :elevation="24"
                    grow
                  >
                    <v-btn style="display: none">
                      <v-icon>mdi-cash</v-icon>
                      COD
                    </v-btn>

                    <v-btn>
                      <v-icon>mdi-bank</v-icon>
                      ONLINE
                    </v-btn>
                  </v-bottom-navigation>
                </v-layout>
              </v-card-actions>
              <!-- <p id="result-json" hidden></p> -->
              <v-card-actions>
                <v-btn color="warning" @click="cancel" id="btn-cancle">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="#1B5E20" @click="midtrans" class="white--text">
                  Continue
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
      </template>
    </v-card>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      courier: "",
      couriers: [],
      service: "",
      services: [],
      shippingCost: 0,
      totalBill: 0,
      dialogConfirm: false,
      absolute: true,
      overlay: false,
      test: true,
      result: "",
      selectedPayment: "",
      dialogProsesed: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      carts: "cart/carts",
      countCart: "cart/count",
      totalPrice: "cart/totalPrice",
      totalQuantity: "cart/totalQuantity",
      totalWeight: "cart/totalWeight",
      setting: "setting/setting",
    }),
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setAuth: "auth/set",
      setCart: "cart/set",
      setPayment: "setPayment",
    }),

    getServices() {
      this.overlay = true;
      let courier = this.courier;
      let encodedCart = JSON.stringify(this.carts);
      let formData = new FormData();
      formData.set("courier", courier);
      formData.set("carts", encodedCart);

      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      this.axios
        .post("/services", formData, config)
        .then((response) => {
          let response_data = response.data;
          // jika tidak error maka data service dan cart akan diupdate.
          if (response_data.status != "error") {
            this.services = response_data.data.services;
            //this.setCart(response_data.data.safe_carts);
            this.overlay = false;
          }

          this.setAlert({
            status: true,
            text: response_data.message,
            color: response_data.status,
          });
        })
        .catch((error) => {
          this.overlay = false;
          let responses = error.response;
          this.setAlert({
            status: true,
            text: responses.data.message,
            color: "error",
          });
        });
    },
    calculateBill() {
      let selectedService = this.services.find((service) => {
        return service.service == this.service;
      });
      this.shippingCost = selectedService.cost;
      this.totalBill =
        parseInt(this.totalPrice) +
        parseInt(this.shippingCost) +
        parseInt(this.setting.midtrans_cost);
      this.isSaveDisabled();
    },
    selectPayment() {
      this.overlay = true;
      this.dialogConfirm = true;
      this.overlay = false;
    },
    midtrans() {
      if (this.selectedPayment == 0) {
        this.setAlert({
          status: true,
          text: "Select Payment",
          color: "warning",
        });
        return;
      }
      this.dialogProsesed = true;
      if (this.selectedPayment == 1) {
        const vm = this;
        let courier = this.courier;
        let service = this.service;
        let safeCart = JSON.stringify(this.carts);
        let formData = new FormData();
        let user = this.user.api_token;
        let totalBill = this.totalBill;

        formData.set("courier", courier);
        formData.set("service", service);
        formData.set("carts", safeCart);
        formData.set("totalBill", totalBill);
        let config = {
          headers: {
            Authorization: "Bearer " + this.user.api_token,
          },
        };
        this.axios
          .post("/midtrans", formData, config)
          .then((response) => {
            let { data } = response;
            let snapToken = data.snapToken;
            window.snap.pay(snapToken, {
              onSuccess: function (result) {
                let formData = new FormData();
                formData.set("courier", courier);
                formData.set("service", service);
                formData.set("carts", safeCart);
                formData.set("json", JSON.stringify(result));
                let config = {
                  headers: {
                    Authorization: "Bearer " + user,
                  },
                };
                vm.axios
                  .post("/payment", formData, config)
                  .then((response) => {
                    console.log(response.data);
                    let { data } = response;
                    if (data && data.status == "success") {
                      vm.setPayment(data.data);
                      vm.setCart([]);
                      vm.$router.push({ path: "/payment" });
                      vm.dialogProsesed = true;
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                vm.dialogConfirm = false;
              },
              onPending: function (result) {
                let formData = new FormData();
                formData.set("courier", courier);
                formData.set("service", service);
                formData.set("carts", safeCart);
                formData.set("json", JSON.stringify(result));
                let config = {
                  headers: {
                    Authorization: "Bearer " + user,
                  },
                };
                vm.axios
                  .post("/payment", formData, config)
                  .then((response) => {
                    console.log(response.data);
                    let { data } = response;
                    if (data && data.status == "success") {
                      vm.setPayment(data.data);
                      vm.setCart([]);
                      vm.$router.push({ path: "/payment" });
                      vm.dialogProsesed = true;
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                  });
                vm.dialogConfirm = false;
              },
              onError: function (result) {
                document.getElementById("btn-cancle").style.display = "block";
                document.getElementById("btn-continue").style.display = "block";
                console.log(result);
                vm.dialogProsesed = true;
              },
              onClose: function () {
                document.getElementById("btn-cancle").style.display = "block";
                document.getElementById("btn-continue").style.display = "block";
                vm.dialogProsesed = true;
              },
            });
            this.setAlert({
              status: true,
              text: data.message,
              color: data.status,
            });
          })
          .catch((error) => {
            this.dialogProsesed = false;
            let { data } = error.response;
            this.setAlert({
              status: true,
              text: data.message,
              color: "error",
            });
          });
      } else {
        //offline payment
        this.dialogProsesed = false;
      }
    },

    cancel() {
      this.dialogConfirm = false;
    },
  },
  created() {
    if (this.couriers.length == 0) {
      this.axios.get("/couriers").then((response) => {
        this.couriers = response.data.data;
      });
    }
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
